import { IoMdPricetag } from 'react-icons/io';
import SectionLabelWithIcon from 'components/typography/SectionLabelWithIcon';
import {
  fontBold,
  justifyContentSpaceBetween,
  text2xl,
  text2xlLineHeight,
  textSm,
  textSmLineHeight,
} from './styleConstants';

export default function PricingSummary({ xMargins = {}, marginTop = {} }) {
  return (
    <>
      <SectionLabelWithIcon
        label="Pricing Summary"
        icon={<IoMdPricetag />}
        iconClassName="text-2xl"
        style={{
          paddingBottom: '1rem',
          borderBottomWidth: '1px',
          ...xMargins,
          ...marginTop,
        }}
        isPdf
      />
      <div
        style={{
          display: 'flex',
          justifyContent: justifyContentSpaceBetween,
          borderBottomWidth: '1px',
          paddingTop: '1rem',
          paddingBottom: '1rem',
          ...xMargins,
        }}
      >
        <div>
          <p style={{ fontWeight: fontBold }}>Total price</p>
          <p style={{ fontSize: textSm, lineHeight: textSmLineHeight }}>
            Final balance due 01 Jun 22
          </p>
        </div>
        <div>£2,100.00</div>
      </div>
      <div
        style={{
          marginTop: '1rem',
          marginBottom: '1rem',
          display: 'flex',
          justifyContent: justifyContentSpaceBetween,
          ...xMargins,
        }}
      >
        <div>
          <p style={{ fontWeight: fontBold }}>Deposit needed to book</p>
          <p style={{ fontSize: textSm, lineHeight: textSmLineHeight }}>
            Due on 01 May 22
          </p>
        </div>
        <div>£100.00</div>
      </div>
      <div
        style={{
          marginTop: '1rem',
          marginBottom: '1rem',
          display: 'flex',
          justifyContent: justifyContentSpaceBetween,
          ...xMargins,
        }}
      >
        <div>
          <p style={{ fontWeight: fontBold }}>Stage 2 Deposit</p>
          <p style={{ fontSize: textSm, lineHeight: textSmLineHeight }}>
            Due on 15 May 22
          </p>
        </div>
        <div>£200.00</div>
      </div>

      <p
        style={{
          marginTop: '2rem',
          marginBottom: '1rem',
          fontWeight: fontBold,
          fontSize: text2xl,
          lineHeight: text2xlLineHeight,
          ...xMargins,
        }}
      >
        Price breakdown
      </p>
      <div
        style={{
          alignItems: 'flex-end',
          display: 'flex',
          paddingBottom: '1rem',
          marginTop: '1rem',
          borderBottomWidth: '1px',
          ...xMargins,
        }}
      >
        <div style={{ flexGrow: '1' }}>Component</div>
        <div style={{ width: '120px', minWidth: '120px', maxWidth: '120px' }}>
          Type
        </div>
        <div style={{ width: '100px', minWidth: '100px', maxWidth: '100px' }}>
          Quantity
        </div>
        <div
          style={{
            width: '120px',
            minWidth: '120px',
            maxWidth: '120px',
            textAlign: 'right',
          }}
        >
          Price per person
        </div>
        <div
          style={{
            width: '150px',
            minWidth: '150px',
            maxWidth: '150px',
            textAlign: 'right',
          }}
        >
          Sub-total
        </div>
      </div>

      <div
        style={{
          alignItems: 'flex-end',
          display: 'flex',
          paddingBottom: '1rem',
          marginTop: '1rem',
          borderBottomWidth: '1px',
          ...xMargins,
        }}
      >
        <div style={{ flexGrow: '1' }}>Package</div>
        <div style={{ width: '120px', minWidth: '120px', maxWidth: '120px' }}>
          Package
        </div>
        <div style={{ width: '100px', minWidth: '100px', maxWidth: '100px' }}>
          1 Unit
        </div>
        <div
          style={{
            width: '120px',
            minWidth: '120px',
            maxWidth: '120px',
            textAlign: 'right',
          }}
        >
          £885.00
        </div>
        <div
          style={{
            width: '150px',
            minWidth: '150px',
            maxWidth: '150px',
            textAlign: 'right',
          }}
        >
          £1,970.00
        </div>
      </div>

      <div
        style={{
          alignItems: 'flex-end',
          display: 'flex',
          paddingBottom: '1rem',
          marginTop: '1rem',
          borderBottomWidth: '1px',
          ...xMargins,
        }}
      >
        <div style={{ flexGrow: '1' }}>Transfers</div>
        <div style={{ width: '120px', minWidth: '120px', maxWidth: '120px' }}>
          Transfers
        </div>
        <div style={{ width: '100px', minWidth: '100px', maxWidth: '100px' }}>
          2 Adults
        </div>
        <div
          style={{
            width: '120px',
            minWidth: '120px',
            maxWidth: '120px',
            textAlign: 'right',
          }}
        >
          Included
        </div>
        <div
          style={{
            width: '150px',
            minWidth: '150px',
            maxWidth: '150px',
            textAlign: 'right',
          }}
        >
          Included
        </div>
      </div>
    </>
  );
}
